<p-dialog header="Verificación de identidad" [(visible)]="visible" [modal]="true"
  [style]="{width: '420px'}" [closable]="!isRecovery && !isBlock" (onHide)="close()" [dismissableMask]="!isRecovery && !isBlock">

  <div class="space-y-5">
    <!-- Descripción -->
    <p class="text-sm text-vivid-royal-500 dark:text-vivid-royal-200 text-center">
      @if (isActivate || isRecovery || isUnlink) {
        Enviamos un código de verificación vía WhatsApp al teléfono del administrador.
      } @else {
        Enviamos un código de verificación {{ IsPhone ? 'vía WhatsApp' : 'por correo electrónico' }} a <span class="font-semibold">{{ hidePhone(phoneNumber, email) }}</span>
      }
    </p>

    <!-- OTP Inputs -->
    <div id="c" *ngIf="OTPForm?.controls" class="flex justify-center gap-3">
      <div class="w-14 h-14" *ngFor="let item of OTPForm?.controls | keys; let i = index">
        <input
          maxlength="1"
          autocomplete="off"
          inputmode="numeric"
          [formControl]="getFormControl(item)"
          id="otp_{{ i }}"
          name="ctrl_{{ i }}"
          class="otp-input w-full h-full text-center rounded-lg border-2 text-lg font-semibold outline-none transition-all duration-200 border-dark-khaki-300 focus:border-vivid-royal-500 focus:ring-2 focus:ring-vivid-royal-200 dark:bg-crayola-blue-800 dark:border-vivid-royal-600 dark:text-white dark:focus:border-mustard-500"
          type="text"
          appOnlyNumbers
          (keydown)="onKeyDown($event)"
          (keyup)="onKeyUp($event, i)"
        />
      </div>
    </div>

    <!-- Error -->
    @if (msgError !== '') {
      <div class="text-sm text-red-700 bg-red-100 border border-red-300 rounded-lg px-3 py-2 text-center">
        {{ msgError }}
      </div>
    }

    <!-- Status message -->
    @if (otpMessage) {
      <p class="text-sm text-center" [ngClass]="otpError ? 'text-red-500' : 'text-green-600'">
        {{ otpMessage }}
      </p>
    }

    <!-- Reenvío -->
    <div class="text-center text-sm text-vivid-royal-400">
      @if (enProceso) {
        <p><i class="pi pi-spin pi-spinner mr-1"></i> Enviando código...</p>
      } @else if (!canResend) {
        <p>Podrás reenviar el código en <span class="font-semibold">{{ timer }}s</span></p>
      } @else if (!isRecovery) {
        <button type="button" class="text-vivid-royal-600 dark:text-mustard-400 hover:underline font-medium" (click)="resend()">
          Reenviar código
        </button>
      }
    </div>
  </div>

  <ng-template #footer>
    @if (!isRecovery && !isBlock) {
      <button pButton label="Cancelar" class="p-button-sm p-button-text" (click)="close()"></button>
    }
    <button pButton [label]="isValidating ? 'Verificando...' : 'Verificar'" class="p-button-sm"
      [icon]="isValidating ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
      [disabled]="isValidating || !otp || otp.length < 4" (click)="verifyOTP()"></button>
  </ng-template>
</p-dialog>
